import { WheelPicker } from './workout/WheelPicker';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { MobileSheet } from './MobileSheet';
import { displayDigits } from '../utils/displayDigits';

/** Duration rather than time of day: allows long workouts without a 24-hour wrap. */
export function WorkoutDurationPicker({ value, onChange }: {
  value?: string | number | null; onChange: (value: string) => void;
}) {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const [hours, setHours] = useState(0);
  const [minutes, setMinutes] = useState(0);
  const parts = String(value ?? '00:00:00').replace(/[۰-۹]/g, digit => String('۰۱۲۳۴۵۶۷۸۹'.indexOf(digit))).split(':');
  const currentHours = Math.max(0, Math.floor(Number(parts[0]) || 0));
  const currentMinutes = Math.max(0, Math.min(59, Math.floor(Number(parts[1]) || 0)));
  const pad = (number: number) => String(number).padStart(2, '0');
  return <>
    <button type="button" className="ws-table__input ltr-island" aria-label={t('durationPicker.title')} onClick={() => { setHours(currentHours); setMinutes(currentMinutes); setOpen(true); }}>
      {displayDigits(`${pad(currentHours)}:${pad(currentMinutes)}`)}
    </button>
    <MobileSheet open={open} onClose={() => setOpen(false)} title={t('durationPicker.title')} zIndex={16000}>
      <div className="workout-duration-wheels" dir="ltr" style={{ display: 'flex', gap: 16, padding: 16 }}>
        <div role="group" aria-label={t('durationPicker.hours')} style={{ flex: 1, minWidth: 0, textAlign: 'center' }}>
          <div>{t('durationPicker.hours')}</div>
          <WheelPicker options={Array.from({ length: Math.max(100, currentHours + 1) }, (_, n) => displayDigits(pad(n)))} selected={hours} onChange={setHours} />
        </div>
        <div role="group" aria-label={t('durationPicker.minutes')} style={{ flex: 1, minWidth: 0, textAlign: 'center' }}>
          <div>{t('durationPicker.minutes')}</div>
          <WheelPicker options={Array.from({ length: 60 }, (_, n) => displayDigits(pad(n)))} selected={minutes} onChange={setMinutes} />
        </div>
      </div>
      <button type="button" className="nm-btn nm-btn--primary" onClick={() => { onChange(`${pad(hours)}:${pad(minutes)}:00`); setOpen(false); }}>{t('common.confirm')}</button>
    </MobileSheet>
  </>;
}
